const styles = (theme) => ({
  container: {
    minWidth: 330,
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
  },
  content: {
    flexGrow: 1,
    overflow: "auto",
  },
  divider: {
    backgroundColor: theme.AppBGColor,
  },
  head: {
    fontSize: 14,
    color: theme.HeaderSelectedText,
    padding: "8px 24px",
    fontWeight: 600,
    flexBasis: "auto",
  },
  dataContainer: {
    padding: "8px 5px",
    fontSize: "12px",
    lineHeight: "16px",
    color: theme.gridTextColor,
  },
  formContainer: {
    display: "flex",
    paddingTop: 16,
  },
  footer: {
    padding: "16px 20px",
    display: "flex",
    justifyContent: "space-between",
  },
  updateButton: {
    minWidth: "55%",
    "&$disabledButton": {
      backgroundColor: theme.customInputBGColor,
      color: theme.TextColor,
      opacity: 0.8,
    },
  },
  disabledButton: {
    backgroundColor: theme.customInputBGColor,
    color: theme.TextColor,
    opacity: 0.8,
  },
  circularProgress: {
    color: theme.white,
  },
  flexRow: {
    display: "flex",
    direction: "column",
    "&>div": {
      flex: 1,
      width: "100%",
    },
  },
  fieldRoot: {},
  label: {
    color: theme.TextColor,
    transform: "translate(14px, 14px) scale(1)",
    fontSize: theme.headerTextFontSize,
    opacity: 0.7,
  },
  notchedOutline: {},
  inputRoot: {
    "& $notchedOutline,&:hover:not($inputFocused):not($inputError) $notchedOutline":
      {
        borderColor: theme.iconColor,
      },
  },
  inputFocused: {},
  inputDisabled: {
    background: theme.tooltipBGColor,
    "& $notchedOutline, &:not($inputFocused):not($inputError) $notchedOutline":
      {
        borderColor: theme.iconColor,
      },
  },
  inputError: {},
  inputField: {
    padding: 8,
    fontSize: theme.textFontSize,
    color: theme.TextColor,
    height: "initial",
  },
  iconClass: {
    color: theme.iconColor,
    cursor: "pointer",
  },
  gridContainer: { margin: "0px", padding: "0px", width: "100%" },
  divStyle: { width: "100%" },
  editorContainer: {
    marginTop: "16px",
    marginBottom: "8px",
  },
  errorMessageVisible: {
    display: "block",
    margin: "5px 0px 0px 12px",
    color: theme.ErrorMessageColor,
    fontSize: theme.textFontSize,
  },

  labelProps: {
    fontSize: theme.headerTextFontSize,
    backgroundColor: theme.gridBGColor,
    color: theme.iconColor,
    padding: "0px 4px 0px 4px",
  },
  filledLabel: {
    top: 4,
    left: 8,
    "&$shrink": {
      transform: "translate(4px, 2px) scale(0.75)",
    },
  },
  shrink: {},

  formClass: { padding: "0px 5px" },
  toggleAnimationButton: {
    float: "left",
    cursor: "pointer",
    padding: "3px 0px",
    display: "flex",
    alignItems: "center",
  },
  toggleAnimationButtonDispatchMap: {
    float: "left",
    cursor: "pointer",
    padding: "3px 8px",
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("md")]: {
      padding: "3px 8px",
    },
  },
  toggleAnimationButtonMenu: {
    justifyContent: "space-between",
  },
  toggleText: {
    display: "inline-block",
    fontSize: "12px",
    color: theme.iconColor,
  },
  noteText: {
    display: "block",
    margin: "5px 0px 0px 12px",
    color: theme.iconColor,
    fontSize: theme.textFontSize,
  },
});

export default styles;
